import { LocalStorageKey } from "@/types";

export const setAuthToken = (token?: string): void => {
  localStorage.setItem(LocalStorageKey.JWT_TOKEN, token);
};
